
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[slug]/[id]",
      function () {
        return require("private-next-pages/event/[slug]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[slug]/[id]"])
      });
    }
  